import React, { useState } from 'react';
import DataTable from 'react-data-table-component';



/*  DATOS MUESTRA
const rows = [{
    id: '1',
    datosLinea: 'Juan Manuel Romero Trejo; MEBL840563UH3; ;543672;',
    descripcion: 'En el renglón 12 el CURP es obligatorio.'
  }
];
*/

const headers = [
    { name: 'ID', selector: rows=>rows['id'], width: '50px', wrap: true},
    { name: 'DATOS DEL RENGLÓN', selector: rows=>rows['datosLinea'], wrap: true},
    { name: 'ERROR', selector: rows=>rows['descripcion'], wrap: true},
];

const ErroresTable = ({ rows }) => {

    return (
        <DataTable
            title=""
            columns={[...headers]}
            data={rows}
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
            highlightOnHover
            searchable
            noDataComponent="No hay datos disponibles"
            paginationComponentOptions={{
                rowsPerPageText: 'Filas por página:',
                rangeSeparatorText: 'de',
                noRowsPerPageText: 'Sin filas por página',
            }}
        />
    );

};

export default ErroresTable;